/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Button, Tooltip } from 'antd';
import SystemAttribute from './SystemAttribute';

const AircardTile = ({ aircard, disabled, index, onReplace }) => {
  const { ip, imsi, esn, type } = aircard;

  const handleReplace = () => {
    onReplace({ ...aircard, index });
  };

  const cssRootContainer = css`
    border-color: #607d8b94;
    background-color: white;
    border-radius: 3px;
    border-style: solid;
    border-width: 2px 0 0 0;
    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, 0.15);
    flex-grow: 1;
    height: 100%;
    margin: 0 0.3rem;
    max-width: 49%;
    padding: 0.7rem 0.8rem 0.8rem 0.8rem;
  `;

  const cssHeader = css`
    align-items: center;
    display: flex;
    font-size: 0.9rem;
    justify-content: space-between;
    margin-bottom: 0.6rem;
  `;

  return (
    <div css={cssRootContainer}>
      <div css={cssHeader}>
        <span css={{ color: '#757575' }}>{`Aircard ${index + 1}`}</span>
        <Tooltip
          overlayStyle={{ textAlign: 'center', fontSize: '0.8rem' }}
          title="System must be active to replace aircard"
          trigger={!!disabled ? 'hover' : 'none'}
        >
          <Button type="link" size="small" onClick={handleReplace} disabled={disabled}>
            Replace
          </Button>
        </Tooltip>
      </div>
      <SystemAttribute label="IP Address" size="small">
        {ip || '- -'}
      </SystemAttribute>
      <SystemAttribute label="IMSI" size="small">
        {imsi || '- -'}
      </SystemAttribute>
      <SystemAttribute label="ESN" size="small">
        {esn || '- -'}
      </SystemAttribute>
      <SystemAttribute label="TYPE" size="small">
        {type || '- -'}
      </SystemAttribute>
    </div>
  );
};

export default AircardTile;
